export const PARTS_SEARCH = 'partsSearch';
export const PARTS_MANUAL = 'partsManual';
export const MANUAL_APPROVAL_MESSAGE = 'isManualApprovalMessageViewed';
export const EQUIPMENT_VALUE = 'equipmentValue';
export const REQUEST_BY_DATE = 'requestByDate';
export const CONSENT = 'consent';
export const LOGON_USER_COOKIE = 'WC_LogonUserId_';
export const QUICK_ORDER_SAVED_ITEMS = 'catSavedQOItems';
export const RCLIST = 'rclist';
export const IS_GUEST = 'isGuest';
export const WC_GUEST_SESSION = 'WC_GUEST_SESSION';
export const QSI_HISTORY_SESSION = 'QSI_HistorySession';
export const CSP_PENDING_APPROVAL_MODAL = 'CSP_PENDING_APPROVAL_MODAL';
export const CMC_OUTAGE_MESSAGE = 'isCmcOutageMessage';
export const MICO_COOKIE = 'mico';
export const DO_NOT_SHOW_PO_NOTIFICATION = 'doNotShowPONotification';
export const USER_INACTIVE = '_userInactive';
export const SFCID = 'SFCID';
export const PRE_SELECTED_PAYMENT_METHOD = 'preSelectedPaymentMethod';
